import regCart from './regCart/reducer';
import {
  ADD_GROUP_MEMBER_FAILURE,
  ADD_GROUP_MEMBER_SUCCESS,
  CALCULATE_PRICING_FAILURE,
  CLEAR_CURRENT_GUEST_EVENT_REGISTRATION,
  CREATE_REG_CART_FAILURE,
  CREATE_REG_CART_SUCCESS,
  DISCOUNT_CODE_VALIDATION_FAILURE,
  FINALIZE_CHECKOUT_FAILURE,
  INITIATE_WAITLIST_REGISTRATION_FAILURE,
  SET_CURRENT_EVENT_REGISTRATION_ID,
  SET_CURRENT_GUEST_EVENT_REGISTRATION,
  SET_TEMPORARY_GUEST_FIELD_VALUE,
  START_MODIFICATION_FAILURE,
  START_WAITLIST_REGISTRATION_CHECKOUT_FAILURE,
  UPDATE_REG_CART_FAILURE,
  UPDATE_REG_CART_SUCCESS
} from './regCart/actionTypes';
import { LOG_IN_REGISTRANT_SUCCESS, LOG_OUT_REGISTRANT_SUCCESS } from '../registrantLogin/actionTypes';
import { setIn } from 'icepick';
import regCartPayment from './regCartPayment/reducer';

export default function reducer(state = {}, action) {
  const newRegCart = regCart(state.regCart, action);
  return {
    currentEventRegistrationId: currentEventRegistrationId(state.currentEventRegistrationId, action),
    regCartPayment: regCartPayment(state.regCartPayment, action),
    regCart: newRegCart,
    errors: errors(state.errors, action),
    currentGuestEventRegistration: currentGuestEventRegistration(
      state.currentGuestEventRegistration, action),
    // keep validation messages in sync with reg cart updates
    validationMessages: action.payload && action.payload.regCart && newRegCart === action.payload.regCart ?
      action.payload.validationMessages :
      state.validationMessages,
    discountCodeStatus: discountCodeStatus(state.discountCodeStatus, action)
  };
}

function currentEventRegistrationId(state = '', action) {
  switch (action.type) {
    case ADD_GROUP_MEMBER_SUCCESS:
    case CREATE_REG_CART_SUCCESS:
    case SET_CURRENT_EVENT_REGISTRATION_ID:
      return action.payload.currentEventRegistrationId;
    case LOG_IN_REGISTRANT_SUCCESS:
    case LOG_OUT_REGISTRANT_SUCCESS:
      return '';
    default:
      return state;
  }
}

function currentGuestEventRegistration(state = {}, action) {
  switch (action.type) {
    case SET_CURRENT_GUEST_EVENT_REGISTRATION:
      return (action.payload && action.payload.currentGuestEventRegistration) || {};
    case SET_TEMPORARY_GUEST_FIELD_VALUE: {
      const { path, value } = action.payload;
      const obj = setIn(state, path, value);
      return obj;
    }
    case CREATE_REG_CART_SUCCESS:
    case LOG_IN_REGISTRANT_SUCCESS:
    case LOG_OUT_REGISTRANT_SUCCESS:
    case CLEAR_CURRENT_GUEST_EVENT_REGISTRATION:
      return {};
    default:
      return state;
  }
}

export function errors(state = {}, action) {
  switch (action.type) {
    case ADD_GROUP_MEMBER_FAILURE:
    case CREATE_REG_CART_FAILURE:
    case UPDATE_REG_CART_FAILURE:
    case FINALIZE_CHECKOUT_FAILURE:
    case CALCULATE_PRICING_FAILURE:
    case START_MODIFICATION_FAILURE:
    case INITIATE_WAITLIST_REGISTRATION_FAILURE:
    case START_WAITLIST_REGISTRATION_CHECKOUT_FAILURE:
      return {
        type: action.type,
        error: action.payload.error
      };
    default:
      return state;
  }
}

function discountCodeStatus(state = '', action) {
  switch (action.type) {
    case UPDATE_REG_CART_SUCCESS:
      return '';
    case DISCOUNT_CODE_VALIDATION_FAILURE:
      return action.payload.validationError;
    default:
      return state;
  }
}
